module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasHeight) ? _c('div', {
    style: (_vm.getStyle),
    attrs: {
      "id": "previewBox"
    },
    on: {
      "mousedown": function($event) {
        _vm.mousedownHandler($event)
      },
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.$emit('keyup.esc')
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$store.state.previewBox.start) + " ~\n  " + _vm._s(_vm.$store.state.previewBox.end) + "\n  "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "show_reservationpopup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show_reservationpopup()
      }
    }
  }, [_vm._v("予約を作成する")]), _c('br')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa223d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/boxes/SpPreviewBox.vue
// module id = 665
// module chunks = 0